import { createActions, handleActions } from 'redux-actions';

const initState = {
  summaryData: {},
  detailData: {},
  fetching: false,
  error: null,
};

export const creators = createActions({
  OPPORTUNITY_SUMMARY_REQUEST: (selectedYears) => ({
    selectedYears,
  }),
  OPPORTUNITY_DETAIL_REQUEST: (selectedYears) => ({
    selectedYears,
  }),
  OPPORTUNITY_SUCCESS: (payload) => payload,
  OPPORTUNITY_FAILURE: (payload) => payload,
});

const summaryReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const detailReducer = (state) => {
  return {
    ...state,
    fetching: true,
    error: null,
  };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    OPPORTUNITY_SUMMARY_REQUEST: summaryReducer,
    OPPORTUNITY_DETAIL_REQUEST: detailReducer,
    OPPORTUNITY_SUCCESS: successReducer,
    OPPORTUNITY_FAILURE: failureReducer,
  },
  initState,
);
